import { useState } from 'react';

import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import { useNavigate } from 'react-router';
import { Alert, AlertTitle, Box } from '@/shared/ui';

import SaveDashboard from '@/assets/icons/SaveDashboard';
import { ConfirmationDialog } from '@/shared/ui/overlays/Modal/ConfirmationDialog';
import Button from '@/shared/ui/primitives/Button';
import { InfoBox } from '@/shared/ui/primitives/InfoBox';
import Typography from '@/shared/ui/typography/Text';

export const SharedDashboardBanner = ({
  user,
  onSave,
  isSaving,
  dashboardName,
  isLoading
}: {
  user: string;
  onSave: () => void;
  isSaving: boolean;
  dashboardName: string;
  isLoading: boolean;
}) => {
  const navigate = useNavigate();
  const [dismissDialogOpen, setDismissDialogOpen] = useState(false);

  return (
    <Box sx={{ mt: 3 }}>
      <InfoBox backgroundColor='gx.response'>
        <Alert
          icon={<GroupsOutlinedIcon />}
          severity='info'
          sx={{
            '& .MuiAlert-icon': {
              color: 'gx.highlight'
            },
            '& .MuiAlert-message': {
              flex: 1
            },
            backgroundColor: 'inherit',
            color: 'inherit'
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
          >
            <Box>
              <AlertTitle sx={{ fontSize: '16px', mb: '8px', fontWeight: 700 }}>
                Dashboard shared with you
              </AlertTitle>
              <Typography sx={{ fontSize: '14px' }}>
                <span style={{ fontWeight: 700 }}>{user}</span> shared "{dashboardName}"
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                gap: '16px'
              }}
            >
              <Button
                disabled={isSaving}
                sx={{
                  width: '152px',
                  height: '40px'
                }}
                variant='outlined'
                onClick={() => {
                  setDismissDialogOpen(true);
                }}
              >
                Dismiss
              </Button>
              <Button
                disabled={isSaving || isLoading}
                startIcon={<SaveDashboard />}
                sx={{
                  width: '250px',
                  height: '40px'
                }}
                onClick={onSave}
              >
                Save to My Dashboards
              </Button>
            </Box>
          </Box>
        </Alert>
      </InfoBox>
      <ConfirmationDialog
        cancelText='Keep browsing'
        confirmText='Dismiss dashboard'
        open={dismissDialogOpen}
        text='You are about to dismiss this shared dashboard'
        title="Don't save this dashboard?"
        onCancel={() => {
          setDismissDialogOpen(false);
        }}
        onConfirm={() => {
          setDismissDialogOpen(false);
          navigate('/dashboard');
        }}
      />
    </Box>
  );
};
